import { NetworkProvider } from "../api/api";
import {
  ChannelEnum,
  ErrorData,
  FactorsEnum,
  SuccessAuthResponseData
} from "../types";
import SessionType from "./sessions.types";

class Session {
  async createSession(
    channel: ChannelEnum,
    factor: FactorsEnum,
    data: SessionType,
    mfaToken: string
  ): Promise<{
    success: boolean;
    exists?: boolean;
    data?: SuccessAuthResponseData;
    errors?: ErrorData[];
  }> {
    const networkProvider = NetworkProvider.getInstance();
    let url = `/sessions/${channel}/${factor}`;
    try {
      let config = {
        headers: {
          "X-Mfa-Token": mfaToken
        }
      };
      var response = await networkProvider.post(url, data, config);
      if (response?.success) {
        return {
          success: true,
          exists: false,
          data: response?.data as SuccessAuthResponseData
        };
      } else {
        if (response?.errors[0].code === 1305) {
          return {
            success: false,
            exists: true,
            errors: response?.errors as ErrorData[]
          };
        } else {
          return { success: false, errors: response?.errors as ErrorData[] };
        }
      }
    } catch (e) {}
    return { success: false };
  }
}

export default Session;
